import { formatDate } from 'v3/utils/controlTowerDate';

export const detailText = (value) =>
  typeof value === 'string' && value.trim() ? value.trim() : 'Não informado';
const instant = (value) => (formatDate(value) === 'Não informado' ? NaN : Date.parse(value));
const coordinate = (value, limit) =>
  typeof value === 'number' && Number.isFinite(value) && Math.abs(value) <= limit;
/** Usa exclusivamente a captura recente do cavalo validada na elegibilidade. */
export function vehicleLocation(candidate, now = Date.now()) {
  if (!candidate) return { state: 'UNSELECTED' };
  const position = candidate.position;
  if (!position) return { state: 'MISSING' };
  const capturedAt = instant(position.capturedAt);
  const validUntil = instant(position.validUntil);
  if (
    position.assetType !== 'VEHICLE' ||
    position.assetId !== candidate.vehicleId ||
    position.source !== 'PLATE_LOCATION' ||
    !Number.isSafeInteger(position.sourceRecordId) ||
    position.sourceRecordId < 1 ||
    position.validity !== 'RECENT_24H' ||
    !coordinate(position.lat, 90) ||
    !coordinate(position.lng, 180) ||
    !Number.isFinite(capturedAt) ||
    capturedAt > now ||
    !Number.isFinite(validUntil) ||
    validUntil !== capturedAt + 86400000
  )
    return { state: 'MISSING' };
  if (validUntil < now) return { state: 'EXPIRED' };
  return { state: 'VALID', position, vehicle: candidate.vehicle };
}

/** Identidade é tipo + ID, nunca o texto da placa nem a posição do array. */
export function customerGroups(candidate, asset) {
  const history = Array.isArray(candidate.plateHistory)
    ? candidate.plateHistory.filter(
        (entry) => entry?.assetType === asset.assetType && entry.assetId === asset.id,
      )
    : null;
  if (history?.length !== 1 || !Array.isArray(history[0].lastCustomerGroups)) return null;
  const groups = history[0].lastCustomerGroups;
  const ids = new Set();
  if (
    groups.length > 5 ||
    !groups.every((group) => {
      if (!Number.isSafeInteger(group?.groupId) || group.groupId <= 0 || ids.has(group.groupId))
        return false;
      ids.add(group.groupId);
      return true;
    })
  )
    return null;
  return groups;
}
